// extracted by mini-css-extract-plugin
export default {"termsContainer":"Copyrights_termsContainer__RinwD","lastUpdated":"Copyrights_lastUpdated__9pPoB"};